<template>
  <span class="badge badge-dark badge-custom">{{ count }}</span>
</template>

<script>
export default {
  props: {
    initialCount: { type: Number, required: true }
  },
  data() {
    return {
      count: this.initialCount
    }
  },
  mounted() {
    EventDispatcher.listen('recordsCountChanged', (payload) => {
      this.count = payload;
    });
  }
}
</script>

<style lang="scss" scoped>
  .badge-custom {
    font-size: 0.75rem;
    padding-right: .6em;
    padding-left: .6em;
    border-radius: 10rem;
    margin:0;
    font-weight:400;
    letter-spacing:.075rem;
    vertical-align: top;
  }
</style>


